import React from "react";

const ASAAS_BADGE_URL_BASE =
  "https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Positivo.svg?id=";

export default function BadgePaymentProvider({
  provedor_pagamento_badge,
  provedor_pgto_badge_ref,
}) {
  if (
    !provedor_pagamento_badge || 
    !provedor_pgto_badge_ref ||
    provedor_pagamento_badge !== "ASAAS"
  ) {
    return null;
  }

  return (
    <img
      src={`${ASAAS_BADGE_URL_BASE}${provedor_pgto_badge_ref}`}
      alt="Selo Banco Asaas"
      width="160"
      height="48"
      style={{ display: "inline-block" }}
    />
  );
}
